
import { Button } from "@/components/ui/button";
import { FreelancerCard, FreelancerProps } from "./FreelancerCard";
import { motion } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { RefObject } from "react";

interface FreelancerSliderProps {
  freelancers: (FreelancerProps & { matchScore?: number })[];
  currentSlide: number;
  setCurrentSlide: (slide: number) => void;
  sliderRef: RefObject<HTMLDivElement>;
  showMatchScore?: boolean;
}

export const FreelancerSlider = ({ 
  freelancers, 
  currentSlide, 
  setCurrentSlide, 
  sliderRef,
  showMatchScore = false 
}: FreelancerSliderProps) => {
  
  const handlePrevSlide = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };

  const handleNextSlide = () => {
    if (currentSlide < freelancers.length - 1) {
      setCurrentSlide(currentSlide + 1);
    }
  };
  
  return (
    <div className="relative overflow-hidden" ref={sliderRef}>
      <div className="flex justify-center items-center">
        <motion.div
          className="w-full max-w-3xl mx-auto"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          {freelancers.length > 0 && (
            <FreelancerCard 
              {...freelancers[currentSlide]} 
              showMatchScore={showMatchScore}
            />
          )}
        </motion.div>
      </div>
      
      <div className="flex justify-center gap-4 mt-6">
        <Button
          variant="outline"
          size="icon"
          onClick={handlePrevSlide}
          disabled={currentSlide === 0}
          className="rounded-full h-12 w-12 text-gray-600 hover:text-sky-600 transition-all duration-300"
        >
          <ChevronLeft className="h-6 w-6" />
        </Button>
        
        <div className="flex items-center">
          <span className="text-sm font-medium text-gray-600">
            {currentSlide + 1} / {freelancers.length}
          </span>
        </div>
        
        <Button
          variant="outline"
          size="icon"
          onClick={handleNextSlide}
          disabled={currentSlide >= freelancers.length - 1}
          className="rounded-full h-12 w-12 text-gray-600 hover:text-sky-600 transition-all duration-300"
        >
          <ChevronRight className="h-6 w-6" />
        </Button>
      </div>
    </div>
  );
};
